module.exports = __webpack_public_path__ + "img/tu1.87878b93.png";